// extracted by mini-css-extract-plugin
module.exports = {"shareButton":"jgp-AJcWH","snapShareButton":"jgp-1WRPA","igShareButton":"jgp-G0k_k"};